// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fw-0";
export var headerCellHover = "_fw-1";
export var readCellContainer = "_fw-2";
export var unreadIndicator = "_fw-3";